/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 缅甸语 国际化语言文件
 */
// 缅甸语.js
export default {
  centerAgent: {
    subagency: "အရန်ကိုယ်စားလှယ်",
    search: "ရှာဖွေရန်",
    subagencyIncome: "အရန်ကိုယ်စားလှယ်၏ဝင်ငွေ",
    last29Days: "လွန်ခဲ့သော ၂၉ ရက်",
    excludingToday: "ယနေ့မပါဝင်ပါ",
    commission: "ကော်မရှင်",
    last30Days: "လွန်ခဲ့သော ရက် ၃၀ အတွက် ဒေတာများ",
    rank: "အဆင့်",
    hostNumber: "အဓိပတိအရေအတွက်",
    recent30Days: "လွန်ခဲ့သော ရက် ၃၀ အတွင်း အဓိပတိဝင်ငွေ",
    commissionRate: "ကော်မရှင်နှုန်း",
    myCommission: "ကျွန်ုပ်၏ ကော်မရှင်",
    remove: "ဖယ်ရှားမည်",
    thisAction:
      "ဤလုပ်ဆောင်ချက်သည် သင့်အဖွဲ့မှ {hostoragent} {hostname} ကို ဖယ်ရှားမည်။ ဆက်လုပ်ဆောင်ရန် အတည်ပြုပါသလား။",
    dashboard: "ဒေတာများပေါင်းစပ်ကြည့်ရှုမှု",
    information: "သတင်းအချက်အလက်",
    dataCenter: "ဒေတာစင်တာ",
    hostList: "အဓိပတိစာရင်း",
    bdList: "BD စာရင်း",
    agencyList: "ကိုယ်စားလှယ်စာရင်း",
    myRight: "ကျွန်ုပ်၏ ခွင့်ပြုချက်များ",
    numberOf: "ကိုယ်စားလှယ်အရေအတွက်",
    inviteAgency: "ကိုယ်စားလှယ်ဖိတ်ခေါ်ရန်",
    numberOfHost: "အဓိပတိအရေအတွက်",
    inviteHost: "အိမ်ရှင်ဖိတ်ခေါ်ရန်",
    inviteHostlinkcopied: "ဖိတ်ကြားချက်လင့်ခ်ကို ကူးယူပြီးပါပြီ",
    tipsShare:
      "အကြံပြုချက်များ : ဖိတ်ကြားချက်လင့်ခ်ကို သင့်သူငယ်ချင်းများနှင့် မျှဝေပါ",
    thisMonthD: "ယခုလ၏ ဒေတာ",
    formDay1: "day1 မှ day2 အထိ",
    hostGift: "အဓိပတိလက်ဆောင်ပွိုင့်များ",
    agentCommission: "ကိုယ်စားလှယ် ကော်မရှင်",
    currentLevel: "လက်ရှိအဆင့်",
    commissionRateOf: "ကိုယ်စားလှယ်များ၏ ဝင်ငွေဆိုင်ရာ ကော်မရှင်နှုန်း",
    baseSalary: "အခြေခံလစာ",
    stillNeed: "လိုနေပါသေးတယ်။",
    toReach: "ရောက်ရှိရန်",
    reachedthe: "ကြော်ငြာ အလုပ်",
    advertisementTask: "ဒေတာ အခြေအနေ",
    dataOverview: "ဒေတာ အခြေအနေ",
    today: "ယနေ့",
    hostPoint: "ဟို့စ် ပွိုင့်",
    agentsPoints: "ကိုယ်စားလှယ် ပွိုင့် ဝင်ငွေ",
    thisMonth: "ဒီလ",
    month: "လ",
    lastMonth: "ပြီးခဲ့သည့်လ",
    bdNumber: "BD အရေအတွက်",
    hostIncome: "ဟို့စ် ဝင်ငွေ",
    todayIncome: "ယနေ့ ဝင်ငွေ",
    past30Days: "လွန်ခဲ့သော ရက် ၃၀",
    host: "အိမ်ရှင်",
    country: "နိုင်ငံ",
    level7: "အဆင့် / ၇-ရက် ဝင်ငွေ",
    pointIncome: "ပွိုင့် ဝင်ငွေ",
    liveDuration: "တိုက်ရိုက်ကာလ",
    joinTime: "အဖွဲ့ဝင် ချိန်",
    state: "အခြေအနေ",
    operation: "လုပ်ဆောင်ချက်",
    bd: "BD",
    totalHosts: "စုစုပေါင်း ဟို့စ် ဝင်ငွေ",
    totalAgents: "စုစုပေါင်း ကိုယ်စားလှယ် ဝင်ငွေ",
    agent: "ကိုယ်စားလှယ်",
    agentLevel: "ကိုယ်စားလှယ် အဆင့် / ကော်မရှင်နှုန်း",
    commissionIncome: "ကော်မရှင် ဝင်ငွေ",
    showDirect: "တိုက်ရိုက်ကိုယ်စားလှယ်များကိုသာ ပြသပါ။ယနေ့ဒေတာမပါဝင်ပါ",
    excludingTodayData: "ယနေ့ဒေတာမပါဝင်ပါ",
    packages: "ပက်ကေ့ချ်များ",
    contents: "အကြောင်းအရာများ",
    balance: "လက်ကျန်",
    release: "ထုတ်ပြန်ရန်",
    issue: "ထုတ်ဝေရန်",
    createBd: "BD ဖန်တီးရန်",
    times: "ကြိမ်",
    authorizeCs: "CS အာဏာအပ်နှင်းရန်",
    giftTo: "အသုံးပြုသူထံ လက်ဆောင်ပေးရန်",
    bdCreation: "BD ဖန်တီးခွင့် ကျန်ရှိသော ကန့်သတ်ချက်",
    csAuthorization: "CS ခွင့်ပြုချက် ကျန်ရှိသော ကန့်သတ်ချက်",
    giftName: "လက်ဆောင် အမည်",
    giftContents: "လက်ဆောင် အကြောင်းအရာ",
    check: "စစ်ဆေးပါ",
    cancel: "ပယ်ဖျက်ပါ",
    tip: "ငွေကြေးဆုချီးမြှင့်ခြင်း",
    recipientsVip:
      "လက်ခံရရှိသူ၏ VIP အဆင့်သည် လက်ဆောင်ပက်ကေ့ချ် ကန့်သတ်ချက်ထက် ကျော်လွန်နေပါသည်။ ဤလက်ဆောင်၏ VIP အခွင့်အရေးများကို ပိတ်ထားမည်။ ဆက်လုပ်ရန် သေချာပါသလား？",
    confirm: "အတည်ပြုပါ",
    authorize: "အာဏာအပ်နှင်းရန်",
    inviteBy: "အသုံးပြုသူ ID ဖြင့် ဖိတ်ကြားရန်",
    invite: "ဖိတ်ကြားရန်",
    inviteLink: "ဖိတ်ခေါ်ရန် လင့်ခ်",
    copy: "ကူးယူပါ",
    success: "အောင်မြင်",
    pleaseCheck: "ကျေးဇူးပြု၍ အသုံးပြုသူ ID ကို စစ်ဆေးပါ",
    totalGift:
      "ဟို့စ်အားလုံး၏ စုစုပေါင်း လက်ဆောင်ဝင်ငွေ (အဆင့်သတ်မှတ်ခြင်း၊ အလုပ်များ စသည့် ပလက်ဖောင်းဆုများ မပါဝင်)၊ လက်အောက်ခံ ကိုယ်စားလှယ်များ၏ လက်ဆောင်ဝင်ငွေပါဝင်သည်။",
    totalAgentsCom:
      "ကိုယ်စားလှယ်များ၏ ဟို့စ်ဝင်ငွေမှ ရရှိသည့် စုစုပေါင်း ကော်မရှင်၊ လက်အောက်ခံ ကိုယ်စားလှယ်များ၏ ကော်မရှင်ပါဝင်သည်။",
    allAgent: "ကိုယ်စားလှယ်အားလုံး",
    directAgent: "တိုက်ရိုက်ကိုယ်စားလှယ်",
    indirectAgent: "သွယ်ဝိုက်သော ကိုယ်စားလှယ်",
    newUpgraded: "အဆင့်မြှင့်တင်ပြီး ကိုယ်စားလှယ်အသစ်",
    newS: "S အဆင့် ကိုယ်စားလှယ်အသစ်များ",
    newB: "B အဆင့် ကိုယ်စားလှယ်အသစ်များ",
    newC: "C အဆင့် ကိုယ်စားလှယ်အသစ်များ",
    expectedReward: "မျှော်မှန်းထားသည့် ဆုချီးမြှင့်ငွေ",
    newA: "A အဆင့် ကိုယ်စားလှယ်အသစ်များ",
    agencyLevel: "ကိုယ်စားလှယ် အဆင့်",
    nickname: "အမည်ပြောင်",
    editNicknameTip:
      "သင်သည် လစဉ်တစ်ခုတွင် သင့အေဂျင်စီအမည်ကို အခမဲ့ပြောင်းလဲနိုင်သည်",
    enterNewNickname: "ကျေးဇူးပြု၍ အမည်ပြောင်းအသစ်ကို ရိုက်ထည့်ပါ",
    nicknameUpdateSuccess: "အမည်ပြောင်း အောင်မြင်စွာ ပြောင်းလဲထားသည်",
    cannotEditNickname: "အမည်ပြောင်း ပြုပြင်၍ရန် မဖြစ်နိုင်ပါ",
    cannotEditTip:
      "အမည်ပြောင်းကို တစ်ခေါက်သာ အခမဲ့ ပြုပြင်နိုင်ပါသည်။ အမည်ပြောင်းပြောင်းလဲနိုင်ရန် ကျေးဇူးပြု၍ ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ။",
    alreadyChangedTip:
      "ဤလတွင် သင့အေဂျင်စီအမည်ကို ပြောင်းပြီးပါပြီ။ ထပ်ပြောင်းမှုများအတွက် 8,000 ဒင်္ဂါးများ ကုန်ကျေးဇူးတောင်းပါသည်။",
    payAndSave: "ပေးပြီး သိမ်းဆည်းပါ",
    upgradeDate: "အဆင့်မြှင့်တင်သည့် ရက်စွဲ",
    bdPolicy: "BD မူဝါဒ",
    agencyDetail: "ကိုယ်စားလှယ် အသေးစိတ်",
    agency: "ကိုယ်စားလှယ် အေဂျင်စီ",
    hostCommission: "ဟို့စ် ကော်မရှင်",
    last6Days: "လွန်ခဲ့သော ရက် ၆ ရက်",
    giftIncome: "လက်ဆောင်ဝင်ငွေ",
    mins: "မိနစ်",
    agencyCenter: "ကိုယ်စားလှယ် စင်တာ",
    myIncome: "ကျွန်ုပ်၏ ယနေ့ဝင်ငွေ",
    totalHost: "စုစုပေါင်း ဟို့စ် ပွိုင့်",
    overview: "အပေါ်ရှုထောင့်",
    hostPoints: "ဟို့စ် ပွိုင့်",
    myHosts: "ကျွန်ုပ်၏ ဟို့စ် ပွိုင့်",
    subagentHost: "လက်အောက်ခံ ကိုယ်စားလှယ် ဟို့စ် ပွိုင့်",
    subagencyNumber: "လက်အောက်ခံ အေဂျင်စီ အရေအတွက်",
    otherIncome: "အခြားဝင်ငွေ",
    contactAdmin: "အက်ဒမင်နှင့် ဆက်သွယ်ရန်",
    whatsapp: "WhatsApp",
    bdCenter: "BD စင်တာ",
    copySuccess: "ကူးယူခြင်း အောင်မြင်ပါသည်",
    pleaseInput: "ကျေးဇူးပြု၍ငွေဖြည့်မည့်ပမာဏကိုရိုက်ထည့်ပါ၊ အနည်းဆုံး 10",
    agencyPolicy: "ကိုယ်စားလှယ် မူဝါဒ",
    agencyCommission: "ကိုယ်စားလှယ် ကော်မရှင်",
    agencyCommission2:
      "ကိုယ်စားလှယ် ကော်မရှင် = ကော်မရှင်နှုန်း × ဟို့စ်အားလုံး၏ စုစုပေါင်း လက်ဆောင်ဝင်ငွေ (အဆင့်သတ်မှတ်ခြင်း၊ အလုပ်များ စသည့် ပလက်ဖောင်းဆုများ မပါဝင်)",
    excludingPlatform:
      "(အဆင့်သတ်မှတ်ခြင်း၊ အလုပ်များ စသည့် ပလက်ဖောင်းဆုများ မပါဝင်)",
    agencyCommissionCalculation: "ကိုယ်စားလှယ် ကော်မရှင် တွက်ချက်ခြင်း",
    level: "အဆင့်",
    pointsTarget: "ပွိုင့် ပစ်မှတ် (ပြီးခဲ့သည့် ရက် ၃၀)",
    points10000: "ပွိုင့် ၁၀,၀၀၀ = ၁ ဒေါ်လာ (M= သန်း)",
    note1:
      "မှတ်ချက် ၁: စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ = သင့်အေဂျင်စီ၏ ဝင်ငွေ + သင့်လက်အောက်ခံ အေဂျင်စီများ၏ အဆင့်တိုင်း၏ ဝင်ငွေ",
    note2:
      "မှတ်ချက် ၂: ဟို့စ်က လက်ဆောင်ရရှိသောအခါ ကိုယ်စားလှယ် ကော်မရှင်များကို အချိန်နှင့်တပြေးညီ သွင်းပေးပါမည်။",
    note3:
      "မှတ်ချက် ၃: အနည်းဆုံး ငွေထုတ်ယူမှု ပမာဏမှာ ၁၀ ဒေါ်လာဖြစ်ပြီး၊ ငွေထုတ်ယူမှုများသည် ၁၀ ၏ ဆခွဲကိန်းများ ဖြစ်ရမည် (ဥပမာ - ၁၀ ဒေါ်လာ၊ ၂၀ ဒေါ်လာ၊ ၃၀ ဒေါ်လာ)။",
    subagencycommission: "လက်အောက်ခံ အေဂျင်စီ ကော်မရှင်",
    theMain:
      "ပင်မ အေဂျင်စီသည် လက်အောက်ခံ အေဂျင်စီများ (T1, T2, T3, T4, ... Tn) ၏ အဆင့်တိုင်း၏ ဝင်ငွေမှ ကော်မရှင်များ ရရှိနိုင်ပြီး အမြင့်ဆုံး ကော်မရှင်နှုန်းမှာ ၁၆% ဖြစ်သည်။",
    forExample: "ဥပမာ -",
    agencyA: "အေဂျင်စီ A က အေဂျင်စီ B နှင့် အေဂျင်စီ C ကို ဖိတ်ကြားသည်။",
    agencyB: "အေဂျင်စီ B က အေဂျင်စီ D နှင့် အေဂျင်စီ E ကို ဖိတ်ကြားသည်။",
    agencyC: "အေဂျင်စီ C က အေဂျင်စီ F ကို ဖိတ်ကြားသည်။",
    noteFigures:
      "(မှတ်ချက် - ကွင်းထဲရှိ ကိန်းဂဏန်းများသည် အေဂျင်စီတစ်ခုစီအောက်ရှိ ဟို့စ်များ၏ ဝင်ငွေကို ကိုယ်စားပြုသည်)။",
    thusWe:
      "ထို့ကြောင့် အေဂျင်စီ A မှ အေဂျင်စီ F အထိ အေဂျင်စီများ၏ စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေနှင့် ကော်မရှင်နှုန်းကို တွက်ချက်နိုင်ပါသည်။",
    totalValid:
      "စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ = သင့်အေဂျင်စီ၏ ဝင်ငွေ + လက်အောက်ခံ အဆင့်တိုင်း၏ ဝင်ငွေ",
    aTotal:
      "A စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (ကော်မရှင်နှုန်း ၂၀%)",
    bTotal:
      "B စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ = B + D + E = 20M + 20M + 30M = 70M (ကော်မရှင်နှုန်း ၁၆%)",
    cTotal:
      "C စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ = C + F = 70M + 80M =150M (ကော်မရှင်နှုန်း ၂၀%)",
    dTotal: "D စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ =20M (ကော်မရှင်နှုန်း ၁၂%)",
    eTotal: "E စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ =30M (ကော်မရှင်နှုန်း ၁၂%)",
    fTotal: "F စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ =80M (ကော်မရှင်နှုန်း ၁၆%)",
    subagencyCommission:
      "လက်အောက်ခံ အေဂျင်စီ ကော်မရှင် = (ပင်မ အေဂျင်စီ ကော်မရှင်နှုန်း - လက်အောက်ခံ အေဂျင်စီ ကော်မရှင်နှုန်း) × လက်အောက်ခံ အေဂျင်စီ၏ စုစုပေါင်း အကျိုးသက်ရောက်သော ဝင်ငွေ",
    agencyAC: "အေဂျင်စီ {A} မှ အေဂျင်စီ {B} ထံမှ ရရှိသော ကော်မရှင်",
    thereforeAgency:
      "ထို့ကြောင့် အေဂျင်စီ {A} သည် လက်အောက်ခံ အေဂျင်စီများထံမှ ရရှိသော စုစုပေါင်း ကော်မရှင်",
    sinceAgency:
      "အေဂျင်စီ D၊ E နှင့် F တို့တွင် လက်အောက်ခံ အေဂျင်စီများ မရှိသောကြောင့် ၎င်းတို့သည် လက်အောက်ခံ အေဂျင်စီ ကော်မရှင်များ မရနိုင်ပါ။",
    seniorPolicy: "အဆင့်မြင့် မူဝါဒ",
    nomore: "ဒေတာမရှိတော့ပါ",
    active: "တက်ကြွသော",
    disabled: "ပိတ်ထားသည်",
    deleted: "ဖျက်ပြီးပြီ",
    lastLogintime: "နောက်ဆုံး အကောင့်ဝင်ချိန်",
    onmic: "ယနေ့ မိုက်ဖွင့်ထားသည်",
  },
  sellerCoin: {
    detailsOf: "ငွေထုတ်ယူမှု အသေးစိတ်",
    fundsSent: "ရန်ပုံငွေ ပေးပို့ပြီး",
    transfer: "လွှဲပြောင်းရန်",
    totalIncome: "စုစုပေါင်းဝင်ငွေ",
    orderIncome: "အော်ဒါ ဝင်ငွေ",
    estimatedReward: "ခန့်မှန်း ဆုကြေး",
    amount: "ပမာဏ",
    applicantId: "လျှောက်ထားသူ ID",
    applicantName: "လျှောက်ထားသူ အမည်",
    orderId: "အော်ဒါ ID",
    uploadScreenshot: "ဖမ်းပုံ တင်ရန်",
    ensureWithdrawal:
      "ငွေထုတ်ယူမှု အောင်မြင်ကြောင်း သေချာစေပြီး ဖမ်းပုံတင်ကာ အောက်ပါခလုတ်ကို နှိပ်ပြီး လျှောက်ထားသူအား အကြောင်းကြားပါ။",
    remain: "ကျန်",
    pleasePay:
      "ချက်ချင်းငွေချေပြီး ရယူလက်မှတ်တင်ပါ။ အချိန်ကျော်လျှင် အမှာစာ၏ ငွေချေအရည်အချင်း ပယ်ဖျက်သွားမည်။",
    youCan: "သင်သည် တစ်နေ့လျှင် ဖိတ်ကြားချက် အမှတ် 5,000 အထိ ရရှိနိုင်သည်။",
    pleaseComplete:
      "ကျေးဇူးပြု၍ ငွေထုတ်ယူမှုကို အချိန်နှင့်ပြည့်စုံစွာ ပြီးစေရန် ",
    unableTo: "ငွေမချေနိုင်၊ ငြင်းပယ်သည်",
    notifyThe: "လျှောက်ထားသူအား အကြောင်းကြားရန်",
    youCanGet:
      "အမှာစာများကို အချိန်နှင့်တပြေးညီ ကိုင်တွယ်ပါက 1%-3% အပိုဆုကြေး ရရှိနိုင်သည်။",
    ifYou: "မိနစ် ၃၀ အတွင်း အမှာစာများကို ကိုင်တွယ်ပါက 3% ဆုကြေး ရရှိနိုင်သည်။",
    egThe:
      "ဥပမာ - ပွိုင့် ၉၀၀၀၀ တန်ဖိုးရှိသော အမှာစာကို မိနစ် ၃၀ အတွင်း ကိုင်တွယ်ပါက 3% ဆုကြေး ရရှိနိုင်ပြီး 90000 × 3% = 2700 ပွိုင့် ဖြစ်သည်။",
    gotIt: "ရပြီ",
    pleaseUpload: "ကျေးဇူးပြု၍ ပုံတင်ပါ",
    detail: "အသေးစိတ်",
    balance: "Balance",
    exchange: "လဲလှယ်ရန်",
    all: "အားလုံး",
    recharge: "ငွေဖြည့်ရန်",
    official: "တရားဝင်",
    exchangeDetail: "လဲလှယ်မှုအသေးစိတ်",
    coinSeller: "ဒင်္ဂါးရောင်းဝယ်သူ",
    levelUp: "အဆင့်မြှင့်တင်ရန်",
    currentLevel: "လက်ရှိအဆင့်",
    myBalance: "ကျွန်ုပ်၏လက်ကျန်",
    details: "အသေးစိတ်",
    paymentMethod: "ငွေချေနည်းလမ်း",
    myOrder: "ကျွန်ုပ်၏အော်ဒါ",
    paymentMenthod: "ငွေချေနည်းလမ်း",
    acceptingOrders: "အော်ဒါလက်ခံနေသည်",
    unavailable: "မရနိုင်ပါ",
    greetingMessage: "ကြိုဆိုရေးမက်ဆေ့ချ်သတ်မှတ်ချက်များ",
    serviceUnavailable: "ဝန်ဆောင်မှုမရနိုင်ပါ",
    thisFeature:
      "ဤအင်္ဂါရပ်ကိုယာယီသော့ခတ်ထားသည်။ ကျေးဇူးပြု၍အကူအညီအတွက်ဖောက်သည်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ။",
    editMessage: "မက်ဆေ့ချ်ကိုတည်းဖြတ်ပါ",
    customizeYour:
      "သင့်ကြိုဆိုရေးမက်ဆေ့ချ်ကိုစိတ်ကြိုက်ပြင်ဆင်ပါ။ ဒင်္ဂါးများငွေဖြည့်ခြင်းအကြောင်းအသုံးဝင်သောအချက်အလက်များထည့်သွင်းနိုင်ပါသည်။",
    theMessage:
      "အသုံးပြုသူအသစ်တစ်ဦးကသင့်အားသီးသန့်စကားပြောဆိုမှုစတင်သောအခါမက်ဆေ့ချ်သည်အလိုအလျောက်ပို့ပါလိမ့်မည်",
    save: "သိမ်းဆည်းပါ",
    pleaseEnterMessge: "ကျေးဇူးပြု၍သင့်ကြိုဆိုရေးမက်ဆေ့ချ်ကိုရိုက်ထည့်ပါ",
    salesMethod: "ရောင်းချနည်းလမ်း",
    user: "အသုံးပြုသူ",
    coinseller: "ဒင်္ဂါးရောင်းဝယ်သူ",
    userId: "အသုံးပြုသူ ID",
    check: "စစ်ဆေးပါ",
    coinAmount: "ဒင်္ဂါးပမာဏ",
    pleaseEnter: "ကျေးဇူးပြု၍ 1 ၏ဆခွဲကိန်းတစ်ခုကိုရိုက်ထည့်ပါ",
    enterAt: "အနည်းဆုံး 100 ကိုရိုက်ထည့်ပါ၊ 1 ၏ဆခွဲကိန်းများဖြင့်",
    transferDetails: "လွှဲပြောင်းမှုအသေးစိတ်",
    recommendSeller: "ရောင်းချသူထောက်ခံပါ",
    recent30Day: "လတ်တလော 30 ရက်အတွင်းဒင်္ဂါးရောင်းချမှု",
    whatsapp: "WhatsApp",
    chat: "စကားပြော",
    yourCountry: "သင့်နိုင်ငံတွင်လက်ရှိဒင်္ဂါးရောင်းဝယ်သူမရှိပါ။",
    pleaseContact: "ကျေးဇူးပြု၍ဖောက်သည်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ။",
    customerSupport: "ဖောက်သည်ဝန်ဆောင်မှု",
    contact: "ဆက်သွယ်ပါ",
    customRecharge: "စိတ်ကြိုက်ငွေဖြည့်ခြင်း",
    rechargeDetails: "ငွေဖြည့်မှုအသေးစိတ်",
    myPoints: "ကျွန်ုပ်၏အချက်များ",
    todayRemaining: "ယနေ့ကျန်ရှိသောကိုတာ",
    customExchange: "စိတ်ကြိုက်လဲလှယ်ခြင်း",
    exchangeDetails: "လဲလှယ်မှုအသေးစိတ်",
    rechargeRules: "ငွေဖြည့်ရန်စည်းမျဉ်းများ",
    sellerLevel: "ရောင်းချသူအဆင့်",
    proportion: "အချိုး",
    levelRequirement: "အဆင့်လိုအပ်ချက်",
    beginner: "အစပြုသူ",
    singleRecharge: "တစ်ကြိမ်တည်းငွေဖြည့်ခြင်း",
    standard: "စံ",
    senior: "အကြီးတန်း",
    exchangeRules: "လဲလှယ်ရန်စည်းမျဉ်းများ",
    note: "Note",
    seniorCoin:
      "အဆင့်မြင့်ရောင်းသူသည် နေ့စဉ်အပြည့်နှုန်းဖြင့် {point} မှတ်အထိ လဲလှယ်နိုင်သည်။ {point} ကျော်လျှင်။",
    beginnerSeller: "အစပြုရောင်းချသူ",
    standardSeller: "စံရောင်းချသူ",
    seniorSeller: "အကြီးတန်းရောင်းချသူ",
    cancel: "Cancel",
    pleaseInput: "Please input the recharge amount, minimum 10",
    pleaseInput2:
      "ကျေးဇူးပြု၍ငွေဖြည့်မည့်ပမာဏကိုရိုက်ထည့်ပါ၊ 100K ၏ဆခွဲကိန်းများ",
    confirmation: "အတည်ပြုခြင်း",
    userName: "အသုံးပြုသူအမည်",
    theUser: "အသုံးပြုသူအားအနက်ရောင်စာရင်းသွင်းထားသည်",
    enterAmount: "ပမာဏကိုရိုက်ထည့်ပါ",
    pleaseInput3: "ကျေးဇူးပြု၍ပမာဏကိုရိုက်ထည့်ပါ",
    theAmount: "ပမာဏသည် 100000 ၏ဆခွဲကိန်းဖြစ်ရမည်",
    pleaseInput4: "ကျေးဇူးပြု၍ပမာဏကိုရိုက်ထည့်ပါသို့မဟုတ်ရွေးချယ်ပါ",
    pleaseSelect: "ကျေးဇူးပြု၍ရောင်းချနည်းလမ်းကိုရွေးချယ်ပါ",
    pleaseInput5: "ကျေးဇူးပြု၍ userId ကိုရိုက်ထည့်ပါ",
    atLeast: "လွှဲပြောင်းရန် အနည်းဆုံး 100K ဒင်္ဂါးများ~",
    pleaseSelect2: "ကျေးဇူးပြု၍ငွေချေနည်းလမ်းကိုရွေးချယ်ပါ",
    minimum: "အနည်းဆုံး",
    theAmount3: "ပမာဏသည် 1 ၏ဆခွဲကိန်းဖြစ်ရမည်",
    lessThan: "100000 ထက်နည်းသို့မဟုတ်ညီမျှ",
    orders: "အော်ဒါများ",
    applicant: "လျှောက်ထားသူ",
    method: "နည်းလမ်း",
    withdrawTime: "ငွေထုတ်ချိန်",
    viewDetail: "အသေးစိတ်ကြည့်ရန်",
    toBe: "အတည်ပြုရန်ကျန်ရှိ",
    toBePaid: "ပေးချေရန်ကျန်ရှိ",
    toBeCompleted: "ပြီးစီးရန်ကျန်ရှိ",
    completed: "ပြီးစီးပြီ",
    abnormal: "ပုံမှန်မဟုတ်",
    refused: "Refused",
    confirmationTimeout: "အတည်ပြုချိန်ကျော်သွားသည်",
    paymentTimeout: "ငွေချေချိန်ကျော်သွားသည်",
    binance: "Binance",
    scanThe: "ငွေချေရန် QR ကုဒ်ကိုစကင်ဖတ်ပါ",
    quantity: "ပမာဏ",
    orderAmount: "အော်ဒါပမာဏ",
    date: "ရက်စွဲ",
    payNow: "အခုပဲပေးချေပါ",
    payment: "ငွေချေခြင်း",
    pleasePay2: "ကျေးဇူးပြု၍အောက်ပါနည်းလမ်းအတိုင်းပေးချေပါ",
    chainName: "ကွင်းဆက်အမည်",
    contractAddress: "စာချုပ်လိပ်စာ",
    theAbove: "အထက်ပါလိပ်စာသည်ဤငွေဖြည့်မှုအတွက်သာသက်တမ်းတိုးထားသည်",
    copy: "Copy",
    notice: "အသိပေးချက်",
    pleaseTransfer:
      "Binance ၏ကြေးအတွက်အပို 1 USDT လွှဲပြောင်းပေးပါ။ မဟုတ်ပါကသင့်ဒင်္ဂါးငွေဖြည့်မှုနောက်ကျနိုင်သည်။",
    paymentsMust:
      "ငွေချေမှုများကို 0.5 နာရီအတွင်းပြီးစီးရမည်၊ သို့မဟုတ်ပလက်ဖောင်းသည်မည်သည့်ပြဿနာအတွက်မှတာဝန်မယူပါ။",
    add: "ထည့်ပါ",
    confirmTo: "ဤငွေချေနည်းလမ်းကိုဖျက်ရန်အတည်ပြုပါ",
    countryCurrency: "နိုင်ငံနှင့်ငွေကြေးအမျိုးအစား",
    selectPayment: "သင်ပို့နိုင်သောငွေချေနည်းလမ်းကိုရွေးချယ်ပါ",
    coinsSeller: "ဒင်္ဂါးရောင်းဝယ်သူစည်းမျဉ်းများ",
    standrd: "စံ",
    salesMethods: "ရောင်းချနည်းလမ်းများ",
    coinsellerRules: "ဒင်္ဂါးရောင်းဝယ်သူစည်းမျဉ်းများ",
    whenApplying:
      "ဒင်္ဂါးရောင်းဝယ်သူအဆင့်အတန်းသို့တိုးမြှင့်ရန်လျှောက်ထားသည့်အခါ၊ အာမိသကငွေမလိုအပ်ပါ ဒင်္ဂါးရောင်းဝယ်သူအဆင့်ကိုတိုးမြှင့်ရန်တစ်ကြိမ်ငွေဖြည့်ရန်သာလိုအပ်သည်။ သင်သည်ဒင်္ဂါးရောင်းဝယ်သူအဖြစ်မှနုတ်ထွက်ရန်ရွေးချယ်ပါကသင့်၏လက်ရှိဒင်္ဂါးရောင်းဝယ်သူအခန်းကဏ္ဍသည်သက်တမ်းကုန်သွားလိမ့်မည်",
    youCanReplenish:
      "သင့်အကောင့်ကို USDT၊ Epay ဖြင့်တိုက်ရိုက်ဖြစ်စေအခြားဒင်္ဂါးရောင်းဝယ်သူမှတစ်ဆင့်ဖြစ်စေငွေဖြည့်နိုင်သည်",
    fraudulentActivities:
      "Hala ပလက်ဖောင်းအတွင်း၏အလွဲသုံးစားမှုများကိုတင်းတင်းကျပ်ကျပ်တားမြစ်ထားသည်။",
    anyViolations:
      "မည်သည့်ချိုးဖောက်မှုမဆိုဒင်္ဂါးရောင်းဝယ်သူအကောင့်၏အဆုံးသတ်ခြင်းဖြစ်စေသည်",
    allRights: "သက်ဆိုင်ရာအခွင့်အရေးအားလုံးကို Hala ကလက်ဝယ်ထားသည်။",
    transferDetail: "လွှဲပြောင်းမှုအသေးစိတ်",
  },
  centerHost: {
    baseSalary: "အခြေခံလစာ",
    invitation: "ဖိတ်ခေါ်ခြင်း",
    tasks: "လုပ်ငန်းများ",
    other: "အခြား",
    consume: "သုံးစွဲခြင်း",
    giftIncome: "Gift Income",
    received: "လက်ခံရရှိပြီ",
    from: "မှ",
    luckyGift: "ကံကောင်းလက်ဆောင်",
    hostCenter: "အိမ်ရှင်ဗဟို",
    noAgent: "ကိုယ်စားလှယ်မရှိ",
    last7: "ပြီးခဲ့သည့် 7 ရက်",
    hourlyIncome: "တစ်နာရီဝင်ငွေ",
    toReach: "to reach",
    rules: "စည်းမျဉ်းများ",
    pointsOverview: "အချက်များအပေါ်အမြင်သဘောထား",
    totalIncome: "စုစုပေါင်းဝင်ငွေ",
    gifts: "လက်ဆောင်များ",
    workDetail: "အလုပ်အသေးစိတ်",
    liveDuration: "Live Duration",
    mins: "mins",
    todaysLive: "ယနေ့လိုင်းမှတ်တမ်း",
    dailyStatistics: "နေ့စဉ်စာရင်းအင်း",
    startTime: "စတင်ချိန်",
    endTime: "ပြီးဆုံးချိန်",
    duration: "ကြာချိန်",
    points: "အမှတ်များ",
    date: "Date",
    giftPoints: "လက်ဆောင်ပွိုင့်",
    removeBinding: "ချိတ်ဆက်မှုဖျက်ပါ",
    thisAction2:
      "ဤလုပ်ဆောင်ချက်သည်သင့်အား {agentName} မှချိတ်ဆက်မှုဖြုတ်ပေးလိမ့်မည်။ ချိတ်ဆက်မှုဖြုတ်ရန်ဆက်လုပ်လိုပါကအတည်ပြုပါ",
  },
  bombRule: {
    afterThe:
      "အခန်းအတွင်းရှိပေါက်ကွဲမှုတန်ဖိုးသည်သတ်မှတ်ပမာဏသို့ရောက်ရှိပြီးနောက်လက်ဆောင်ဗုံးသည်အခန်းအတွင်းပေါ်လာလိမ့်မည်",
    oneCoins: "အခန်းအတွင်းလက်ခံရရှိသောဒင်္ဂါး 1 ပြား = ပေါက်ကွဲမှုတန်ဖိုး 1",
    itWill:
      "လိုအပ်ချက်များနှင့်ပြည့်မီပြီးနောက်အလိုအလျောက်ပေါက်ကွဲလိမ့်မည်၊ ပြီးနောက်အခန်းပိုင်ရှင်သည်သက်ဆိုင်ရာရွှေဒင်္ဂါးဆုချီးမြှင့်မှုများရရှိလိမ့်မည်",
  },
  descriptionLevel: {
    wealth: "ချမ်းသာ",
    charm: "ဆွဲဆောင်မှု",
    wealthValue: "ချမ်းသာမှုတန်ဖိုး",
    charmValue: "ဆွဲဆောင်မှုတန်ဖိုး",
    needTo: "လိုအပ်သည်",
    send: "ပို့ပါ",
    receive: "လက်ခံပါ",
    forThe: "အဆင့်မြှင့်တင်ရန်",
    theRich: "ချမ်းသာသောအဆင့်သည်သင်ငွေဖြည့်ထားသောဒင်္ဂါးများဖြင့်ရေတွက်သည်",
    theCharm:
      "ဆွဲဆောင်မှုအဆင့်သည်သင်လက်ခံရရှိသောဒင်္ဂါးအရေအတွက်ပေါ်မူတည်၍တွက်ချက်သည်",
    LevelLabel: "အဆင့်တံဆိပ်",
    level: "Level",
    levelLogo: "အဆင့်လိုဂို",
  },
  gameRank: {
    gameRank: "ဂိမ်းအဆင့်",
    rules: "Rules",
    thisWeek: "ဒီရက်သတ္တပတ်",
    lastWeek: "ပြီးခဲ့သည့်အပတ်",
    agentGaming: "ကိုယ်စားလှယ်ဂိမ်းဝင်ငွေအဆင့်",
    rankingRewards: "အဆင့်သတ်မှတ်ဆုချီးမြှင့်မှုများ",
    rankingIs:
      "အဆင့်သတ်မှတ်ခြင်းသည်ကိုယ်စားလှယ်အခန်းနှင့်၎င်း၏အခန်းခွဲများရှိအသုံးပြုသူများ၏စုစုပေါင်းဗက်တင်လှည့်ပတ်မှုပေါ်မူတည်သည်။",
    hostRoom: "အိမ်ရှင်အခန်းဝင်ငွေအဆင့်",
    rankingIs2:
      "အဆင့်သတ်မှတ်ခြင်းသည်အိမ်ရှင်အခန်းတွင်ထုတ်လုပ်သောစုစုပေါင်းဂိမ်းဝင်ငွေပေါ်မူတည်သည်",
    notes: "မှတ်ချက်များ",
    eventDuration:
      "ပွဲကြာချိန်- ပြက္ခဒိန်အပတ်တိုင်း။ ဆုချီးမြှင့်မှုများကိုသာလျှင်ဖြန့်ဝေသည်",
    rewardsAre:
      "Rewards are distributed only if the corresponding revenue requirements are met.",
    allRewards:
      "All rewards will be issued within 1-2 working days after the event ends.",
    halaReserves:
      "Hala သည်ဤပွဲ၏နောက်ဆုံးအနက်ဖွင့်ဆိုချက်အခွင့်အရေးကိုလက်ဝယ်ထားသည်",
    rewardsDetail: "ဆုချီးမြှင့်မှုအသေးစိတ်",
    decorationsPreview: "အလှဆင်မှုအစမ်းကြည့်ခြင်း",
  },
  gameLegacyHall: {
    surpriseLucky: "အံ့အားသင့်ဖွယ်ကံကောင်းအိတ်",
    dailyPlayers:
      "နေ့စဉ်ကစားသမားများသည်ကျပန်းဒင်္ဂါးများအတွက်နောက်တစ်နေ့တွင်ကံကောင်းအိတ်ကိုဖွင့်နိုင်သည်",
    eventRule: "ပွဲစည်းမျဉ်း",
    usersSpending:
      "ပွဲဂိမ်းများတွင်အသုံးပြုသူများ၏ငွေသုံးစွဲမှုသည်သူတို့၏အဆင့်သတ်မှတ်ရမှတ်တွင်ထည့်သွင်းတွက်ချက်လိမ့်မည်",
    thePlatform:
      "ပလက်ဖောင်းသည် 4 နာရီတိုင်းပွဲဂိမ်းများလည်ပတ်မည်၊ တစ်လှည့်လျှင်မတူညီသောဂိမ်း 4 မျိုးပါဝင်သည်",
    theTop:
      "နေ့စဉ်ထိပ်တန်း 3 ဦးကစားသမားများသည်ဘောင်များနှင့်ဒင်္ဂါးဆုချီးမြှင့်မှုများရရှိလိမ့်မည်",
    theTop2:
      "အပတ်စဉ်ထိပ်တန်း 10 ဦးကစားသမားများသည်ဘောင်များနှင့်ဒင်္ဂါးဆုချီးမြှင့်မှုများရရှိလိမ့်မည်",
    usersWho:
      "နေ့စဉ်ပွဲဂိမ်းများတွင်ပါဝင်သည့်အသုံးပြုသူများသည်ကျပန်းဒင်္ဂါးအရေအတွက်ရရှိရန်နောက်တစ်နေ့တွင်ကံကောင်းအိတ်ကိုဖွင့်နိုင်သည်။ ပွဲဂိမ်းများတွင်သင်ပိုမိုသုံးစွဲလေလေ၊ ပိုမိုသောဒင်္ဂါးများရရှိနိုင်လေဖြစ်သည်",
    behindPrevious: "ယခင်နောက်တွင်",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    countdown: "ရေတွက်ခြင်း-",
    days: "နေ့ရက်များ",
    winOver: "ထက်ပိုအောင်နိုင်",
    coinsfrom: "တစ်ရက်တည်းဂိမ်းများမှဒင်္ဂါးများ",
    earnOver: "ထက်ပိုရရှိပါ",
    coinsWitdh: "ပြန်လည်ရရှိမှုနှုန်းအထိ",
    fromOneDay: "တစ်ရက်မှ",
    game: "ဂိမ်း",
    fromA: "တစ်ကြိမ်တည်းဗက်တွင်မှ",
    inthisWeek: "ဒီရက်သတ္တပတ်အတွင်း",
    earnUp: "အထိ၍ရရှိပါ",
    inAsingle: "တစ်ရက်တည်းအတွင်း",
    eventRules: "ပွဲစည်းမျဉ်းများ",
    participateIn:
      "မနက်ဖြန်ပိုကြီးသောကံကောင်းအိတ်ကိုတောင်းဆိုရန်ဂိမ်းတွင်ပါဝင်ပါ",
    youDid:
      "သင်သည်ဒင်္ဂါးဆုချီးမြှင့်မှုမရရှိပါ။ ဂိမ်းတွင်ပါဝင်ပါကမနက်ဖြန်ကံကောင်းအိတ်ကိုဆက်လက်တောင်းဆိုနိုင်သည်",
    participateIn2:
      "ဂိမ်းတွင်ပါဝင်ပါကမနက်ဖြန်ကံကောင်းအိတ်ကိုဆက်လက်တောင်းဆိုနိုင်သည်",
    topDaily: "နေ့စဉ်ဒင်္ဂါးအောင်နိုင်သူထိပ်တန်း",
    topPayout: "အမြင့်ဆုံးငွေချေနှုန်းအောင်နိုင်သူ",
    topCoins: "အပတ်စဉ်တစ်ပတ်လျှင်တစ်ကြိမ်ဒင်္ဂါးအောင်နိုင်သူထိပ်တန်း",
    topPayout2: "အပတ်စဉ်တစ်ပတ်လျှင်တစ်ကြိမ်အမြင့်ဆုံးငွေချေနှုန်းအောင်နိုင်သူ",
    topWeekly: "အပတ်စဉ်ဒင်္ဂါးအောင်နိုင်သူထိပ်တန်း",
    historicalTop: "သမိုင်းဝင်တစ်ရက်တည်းဒင်္ဂါးအောင်နိုင်သူထိပ်တန်း",
    historicalTop2: "သမိုင်းဝင်တစ်ရက်တည်းအမြင့်ဆုံးငွေချေနှုန်းအောင်နိုင်သူ",
    historicalTop3: "သမိုင်းဝင်တစ်ပတ်လျှင်တစ်ကြိမ်ဒင်္ဂါးအောင်နိုင်သူထိပ်တန်း",
    historicalTop4:
      "သမိုင်းဝင်တစ်ပတ်လျှင်တစ်ကြိမ်အမြင့်ဆုံးငွေချေနှုန်းအောင်နိုင်သူ",
    historicalTop5: "သမိုင်းဝင်တစ်ပတ်တည်းဒင်္ဂါးအောင်နိုင်သူထိပ်တန်း",
    gameReward: "ဂိမ်းဆုချီးမြှင့်မှု",
    usersSpending2:
      "ပွဲဂိမ်းများတွင်အသုံးပြုသူများ၏ငွေသုံးစွဲမှုသည်သူတို့၏အဆင့်သတ်မှတ်ရမှတ်တွင်ထည့်သွင်းတွက်ချက်လိမ့်မည်",
    theTop3:
      "နေ့စဉ်ထိပ်တန်း 3 ဦးကစားသမားများသည်ဘောင်များနှင့်ဒင်္ဂါးဆုချီးမြှင့်မှုများရရှိလိမ့်မည်",
    theTop4:
      "အပတ်စဉ်ထိပ်တန်း 10 ဦးကစားသမားများသည်ဘောင်များနှင့်ဒင်္ဂါးဆုချီးမြှင့်မှုများရရှိလိမ့်မည်",
    usersWho2:
      "နေ့စဉ်ပွဲဂိမ်းများတွင်ပါဝင်သည့်အသုံးပြုသူများသည်ကျပန်းဒင်္ဂါးအရေအတွက်ရရှိရန်နောက်တစ်နေ့တွင်ကံကောင်းအိတ်ကိုဖွင့်နိုင်သည်။ ပွဲဂိမ်းများတွင်သင်ပိုမိုသုံးစွဲလေလေ၊ ပိုမိုသောဒင်္ဂါးများရရှိနိုင်လေဖြစ်သည်",
    coins: "ဒင်္ဂါးပြားများ",
    flameRider: "မီးလျှပ်စီးစီးသူ",
    sportCar: "အားကစားကား",
    captainMeow: "ကပ္ပတိန်မီယော",
    profileFrame: "ပရိုဖိုင်ဘောင်ကြောင့်",
  },
  gold: {
    coinsDetail: "ဒင်္ဂါးအသေးစိတ်",
    coinBalance: "ဒင်္ဂါးလက်ကျန်",
    all: "ALL",
    sendGifts: "လက်ဆောင်များပို့ပါ",
    purchaseItems: "ပစ္စည်းများဝယ်ယူပါ",
    games: "ဂိမ်းများ",
    exchange: "Exchange",
    recharge: "Recharge",
    activeReword: "အချုပ်ရှုံ့များသူးရေးခုံများ",
  },
  integral: {
    all: "All",
    cashOut: "ငွေထုတ်ရန်",
    transfer: "Transfer",
    orderId: "Order ID",
    paymentMenthod: "Payment Menthod",
    withdrawalTime: "ငွေထုတ်ချိန်",
    pointsAmount: "အချက်ပမာဏ",
    depositAmount: "ငွေသွင်းပမာဏ",
    coinsAmount: "ဒင်္ဂါးပမာဏ",
    transferTo: "သို့လွှဲပြောင်းပါ",
    normal: "ပုံမှန်",
    pending: "ဆိုင်းငံ့ဆဲ",
    success: "Success",
    failed: "ကျရှုံး",
    points: "Points",
    pointsBalance: "အချက်လက်ကျန်",
    frozenPoints: "ခဲအချက်များ",
    details: "အသေးစိတ်",
    exchange: "Exchange",
    currencyType: "ငွေကြေးအမျိုးအစား",
    paymentMethod: "Payment method",
    pointsAmount2: "ငွေထုတ်ရန်အချက်ပမာဏ",
    enterA: "100,000 ၏ဆခွဲကိန်းတစ်ခုကိုရိုက်ထည့်ပါ (အနည်းဆုံး 200,000)",
    enterA2: "100000 ၏ဆခွဲကိန်းတစ်ခုကိုရိုက်ထည့်ပါ",
    accountInformation: "အကောင့်အချက်အလက်",
    withdraw: "ငွေထုတ်ရန်",
    amount: "ပမာဏ",
    exchangeRate: "ငွေလဲနှုန်း",
    exchangePoints: "လဲလှယ်ရန်အချက်များ",
    enterUserId: "အသုံးပြုသူ ID ကိုရိုက်ထည့်ပါ",
    check: "Check",
    fee: "ကြေး",
    theAgency: "ကိုယ်စားလှယ်ရရှိလိမ့်မည်",
    transferFee:
      "လွှဲပြောင်းကြေး- 2%။ အနည်းဆုံးလွှဲပြောင်းမှု ≥ 100,000 ပွိုင့်။",
    clickTransfer:
      "သင့်ကိုယ်စားလှယ်များထံသက်ဆိုင်ရာအချက်များလွှဲပြောင်းရန်လွှဲပြောင်းခလုတ်ကိုနှိပ်ပါ",
    afterThe2:
      "လွှဲပြောင်းမှုပြီးဆုံးပြီးနောက်ပယ်ဖျက်ခြင်းသို့မဟုတ်ရုပ်သိမ်းခြင်းမပြုနိုင်ပါ",
    transferPoints: "အချက်များလွှဲပြောင်းရန်",
    recommendedMethod: "အကြံပြုထားသောနည်းလမ်း",
    lowerFees: "ကြေးနှုန်းချိုသာပြီး 24 နာရီအတွင်းသုံးသပ်သည်",
    paymentPassword: "ငွေချေစကားဝှက်သတ်မှတ်မထားပါ",
    cashOut2:
      "ငွေထုတ်ခြင်းနှင့်လဲလှယ်ခြင်းများသည်ငွေချေစကားဝှက်အတည်ပြုချက်လိုအပ်သည်။ ကျေးဇူးပြု၍သင့်ငွေချေစကားဝှက်ကိုအရင်သတ်မှတ်ပါ။",
    cancel: "Cancel",
    goTo: "ဆက်တင်များသို့သွားပါ",
    youHave:
      "သင် မအောင်မြင်သော ကြိုးပမ်းမှု ၅ ကြိမ် ရောက်ရှိပြီ။ နောက်ထပ် မအောင်မြင်သော ကြိုးပမ်းမှုတစ်ကြိမ် ပြုလုပ်ပါက သင့်အကောင့် ခဲသွားမည်။ သင့်စကားဝှက်ကို မေ့နေပါက၊ ပြန်လည်သတ်မှတ်ပေးပါ။",
    inputIncorrect:
      "မှားယွင်းသောစကားဝှက်ကိုအကြိမ်များစွာရိုက်ထည့်မိသည်။ သင့်အကောင့်အားခဲသွားပြီ၊ ကျေးဇူးပြု၍ပြီးနောက်ထပ်ကြိုးစားကြည့်ပါ",
    verify: "အတည်ပြုပါ",
    gotIt: "Got it",
    pointsInfo: "အချက်အလက်အချက်များ",
    whenA:
      "အသုံးပြုသူတစ်ဦးကဂူဂဲလ်မှငွေဖြည့်ထားသောဒင်္ဂါးများဖြင့်သင့်အားလက်ဆောင်များပို့သောအခါသင်လက်ခံရရှိသောအချက်များသည်ရရှိနိုင်မီ 7 ရက်ကြာခဲသွားလိမ့်မည်။ အသုံးပြုသူကငွေပြန်အမ်းရန်တောင်းဆိုပါကထိုအချက်များကိုနုတ်ယူလိမ့်မည်။ ကျေးဇူးပြု၍ပလက်ဖောင်းစည်းမျဉ်းများကိုလိုက်နာပါနှင့်မည်သည့်ချိုးဖောက်မှုကိုမဆိုရှောင်ကြဉ်ပါ။",
    frozenPointsAre: "ခဲအချက်များသည်စုစုပေါင်းအချက်လက်ကျန်တွင်ပါဝင်သည်",
    theUser2: "အသုံးပြုသူအားအနက်ရောင်စာရင်းသွင်းထားသည်",
    successfulWithdrawal: "အောင်မြင်သောငွေထုတ်ယူမှု",
    withdrawalAmount: "ငွေထုတ်ယူမည့်ပမာဏ",
    theFunds: "ရန်ပုံငွေများ 24 နာရီအတွင်းရောက်ရှိလိမ့်မည်",
    pleaseEnter2: "ကျေးဇူးပြု၍စကားဝှက်ကိုရိုက်ထည့်ပါ",
    passwordIncorrect: "စကားဝှက်မှားယွင်းနေသည်",
    theAmount4: "ပမာဏသည် 100000 ၏ဆခွဲကိန်းဖြစ်ရမည်",
    pleaseEnter3: "ကျေးဇူးပြု၍ User ID ကိုရိုက်ထည့်ပါ",
    pleaseEnter4: "ကျေးဇူးပြု၍မှန်ကန်သော User ID ကိုရိုက်ထည့်ပါ",
    pleaseEnter5: "ကျေးဇူးပြု၍ပမာဏကိုရိုက်ထည့်ပါ",
    minimumTransfer: "အနည်းဆုံးလွှဲပြောင်းမှု ≥ 100,000 ပွိုင့်",
    pleaseSelect3: "ကျေးဇူးပြု၍နည်းလမ်းကိုရွေးချယ်ပါ",
    minimum: "minimum",
    theAmount5: "ပမာဏသည်ထက်နည်းရမည်",
    illegalInput: "တရားမဝင်သောထည့်သွင်းမှု",
    pleaseEnter6: "ကျေးဇူးပြု၍အကောင့်အချက်အလက်ကိုရိုက်ထည့်ပါ",
  },
  invite: {
    inviteGame: "ဂိမ်းအသုံးပြုသူဖိတ်ခေါ်ရန်",
    currentRebate: "လက်ရှိပြန်အမ်းငွေ",
    need: "လိုအပ်သည်",
    toProgress: "နောက်တစ်ဆင့်သို့တိုးတက်ရန်",
    gameReward: "Game Reward",
    referralData: "ညွှန်ကြားရေးဒေတာ",
    referralList: "ညွှန်ကြားရေးစာရင်း",
    date: "Date",
    gameBets: "ဂိမ်းဗက်များ",
    inviteRewards: "ဖိတ်ခေါ်ဆုချီးမြှင့်မှုများ",
    viewMore: "ပိုမိုကြည့်ရန်",
    inviteFriends: "မိတ်ဆွေများဖိတ်ခေါ်ရန်",
    myReward: "ကျွန်ုပ်၏ဆုချီးမြှင့်မှု",
    totalRewards: "စုစုပေါင်းဆုချီးမြှင့်မှုများ",
    dailyReward: "နေ့စဉ်ဆုချီးမြှင့်မှု",
    inviteRules: "ဖိတ်ခေါ်ရန်စည်းမျဉ်းများ",
    yourRebate:
      "သင့်ပြန်အမ်းနှုန်းသည်သင့်နောက်ဆုံး 30 ရက်အတွင်းစုစုပေါင်းတရားဝင်ဗက်များအပေါ်မူတည်သည်",
    totalValid2:
      "စုစုပေါင်းတရားဝင်ဗက်များ = သင့်ကိုယ်ပိုင်ဗက်များ + သင့်ဖိတ်ခေါ်ထားသောအသုံးပြုသူများ၏တစ်ဆင့်ချင်းစီ၏ကိုယ်ပိုင်ဗက်များ",
    rebateFrom:
      "Tier-1 ဖိတ်ခေါ်ထားသောအသုံးပြုသူများမှပြန်အမ်းငွေ = သူတို့၏ကိုယ်ပိုင်ဗက်များ × သင့်ပြန်အမ်းနှုန်း",
    rebateFrom2:
      "Tier-2 ဖိတ်ခေါ်ထားသောအသုံးပြုသူများမှပြန်အမ်းငွေ = သူတို့၏ကိုယ်ပိုင်ဗက်များ × (သင့်ပြန်အမ်းနှုန်း - Tier-1 ပြန်အမ်းနှုန်း)",
    ifThe:
      "Tier-2 ဖိတ်ခေါ်ထားသောအသုံးပြုသူသည် Tier-3 အသုံးပြုသူအားဖိတ်ခေါ်ပါကသူ၏စုစုပေါင်းတရားဝင်ဗက်များတိုးမြှင့်နိုင်သော်လည်းသူသည် Tier-3 မှပြန်အမ်းငွေမရနိုင်ပါ။",
    example: "နမူနာ",
    tier1:
      "Tier-1 ဖိတ်ခေါ်ခံရ - သင့်အားတိုက်ရိုက်ဖိတ်ခေါ်သူများထံမှပြန်အမ်းငွေကိုမည်သို့တွက်ချက်မည်နည်း။",
    asRebate:
      "B၊ C နှင့် D မှ A ၏ပြန်အမ်းငွေ = (B ၏ကိုယ်ပိုင်ဗက် + C ၏ကိုယ်ပိုင်ဗက် + D ၏ကိုယ်ပိုင်ဗက်) × A ၏ပြန်အမ်းနှုန်း =",
    bsRebate:
      "E နှင့် F မှ B ၏ပြန်အမ်းငွေ = (E ၏ကိုယ်ပိုင်ဗက် + F ၏ကိုယ်ပိုင်ဗက်) × B ၏ပြန်အမ်းနှုန်း =",
    csRebate: "G မှ C ၏ပြန်အမ်းငွေ = G ၏ကိုယ်ပိုင်ဗက် × C ၏ပြန်အမ်းနှုန်း =",
    tier2:
      "Tier-2 ဖိတ်ခေါ်ခံရ - သင့်အားသွယ်ဝိုက်၍ဖိတ်ခေါ်သူများထံမှပြန်အမ်းငွေကိုမည်သို့တွက်ချက်မည်နည်း။",
    asRebate2:
      "E နှင့် F မှ A ၏ပြန်အမ်းငွေ = (A ၏ပြန်အမ်းနှုန်း - B ၏ပြန်အမ်းနှုန်း) × (E ၏ကိုယ်ပိုင်ဗက် + F ၏ကိုယ်ပိုင်ဗက်) =",
    asRebate3:
      "G မှ A ၏ပြန်အမ်းငွေ = (A ၏ပြန်အမ်းနှုန်း - C ၏ပြန်အမ်းနှုန်း) × G ၏ကိုယ်ပိုင်ဗက် =",
    myInvitation: "ကျွန်ုပ်၏ဖိတ်ခေါ်ခြင်း",
    search: "Search",
    invitationTime: "ဖိတ်ခေါ်ချိန်",
    inviteHost: "Invite Host",
    inviteA: "အိမ်ရှင်တစ်ဦးဖိတ်ခေါ်ရန်၊ တစ်ဦးလျှင်အများဆုံး",
    todayRewards: "ယနေ့ဆုချီးမြှင့်မှုများ",
    rewardDetail: "ဆုချီးမြှင့်မှုအသေးစိတ်",
    creatorRewards: "ဖန်တီးသူဆုချီးမြှင့်မှုပိုက်ဆံအိတ်",
    collect: "ကောက်ခံပါ",
    invitationDate: "ဖိတ်ခေါ်သည့်ရက်စွဲ",
    hostPolicy: "အိမ်ရှင်မူဝါဒ",
    halaReserves2:
      "Hala သည်အထက်ပါမူဝါဒများ၏နောက်ဆုံးအနက်ဖွင့်ဆိုချက်အခွင့်အရေးကိုလက်ဝယ်ထားသည်။",
  },
  listContribution: {
    contributiont: "ပံ့ပိုးမှု",
    host: "Host",
    wealth: "Wealth",
    today: "Today",
    yesterday: "မနေ့က",
    game: "Game",
    gift: "လက်ဆောင်",
    hostEarnings: "အိမ်ရှင်ဝင်ငွေ",
  },
  missionRule: {
    hostPolicy: "Host Policy",
    halaReserves3:
      "Hala သည်အထက်ပါမူဝါဒများ၏နောက်ဆုံးအနက်ဖွင့်ဆိုချက်အခွင့်အရေးကိုလက်ဝယ်ထားသည်",
  },
  purchase: {
    recharge: "Recharge",
    userId: "User ID",
    confirm: "Confirm",
    switchAccount: "အကောင့်ပြောင်းရန်",
    countryRegion: "နိုင်ငံ/ဒေသ",
    officialAgency: "တရားဝင်ကိုယ်စားလှယ်ငွေဖြည့်ခြင်း",
    ttOff: "၂၀% လျှော့",
    totalAmount: "စုစုပေါင်းပမာဏ",
    purchase: "ဝယ်ယူပါ",
    pleaseComfirm: "ကျေးဇူးပြု၍ User ID ကိုအတည်ပြုပါ",
    pleaseInput8: "ကျေးဇူးပြု၍ User ID ကိုရိုက်ထည့်ပါ",
    onlineService: "အွန်လိုင်းဝန်ဆောင်မှု",
    dealOf: "ပြီးခဲ့သည့် 30 ရက်အတွင်းလုပ်ဆောင်မှု",
    recent30Day2: "လတ်တလော 30 ရက်အတွင်းဒင်္ဂါးရောင်းချမှု",
    paymentMethod: "Payment Method",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry2: "သင့်နိုင်ငံတွင်လက်ရှိဒင်္ဂါးရောင်းဝယ်သူမရှိပါ",
    pleaseContact2: "ကျေးဇူးပြု၍ဖောက်သည်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ။",
    customerSupport: "customer support",
    contact: "Contact",
  },
  roomGiftRule: {
    eventRules: "Event Rules",
    treasureChest:
      "အခန်းအတွင်းလက်ဆောင်များပေးခြင်းဖြင့်ပြတိုက်သေတ္တာတိုးတက်မှုတိုးပွားစေသည်",
    whenThe:
      "သေတ္တာသော့၏တိုးတက်မှုဘားပြည့်သွားသောအခါပြတိုက်သေတ္တာဖွင့်လိမ့်မည်",
    afterThe3:
      ".အဆင့် 3 နှင့်အဆင့် 4 ပြတိုက်သေတ္တာများလိုအပ်ချက်များနှင့်ပြည့်မီပြီးနောက် 1 မိနစ်ကြာသော့ခတ်ပြီးအလိုအလျောက်ဖွင့်လိမ့်မည်",
    everyoneIn:
      "အခန်းရှိလူတိုင်းသည် ရတနာသေတ္တာတွင် ဆုများရရန် အခွင့်အရေးရှိသည်။",
    onceThe:
      "ရတနာသေတ္တာကိုဖွင့်ပြီးသည်နှင့် သင့်အကောင့်သို့ ဆုငွေထုတ်ပေးရန်အတွက် စနစ်က မိနစ်အနည်းငယ်ကြာနိုင်သည်။ ရွှေဒင်္ဂါးများကို သင့်လက်ကျန်ထဲသို့ ပေါင်းထည့်မည်ဖြစ်ပြီး ဝတ်စုံကို သင့်စာရင်းတွင် ထည့်သွင်းမည်ဖြစ်သည်။",
    theHigher: "ရတနာသေတ္တာ၏အဆင့်မြင့်လေ၊ ၎င်းတွင်ဆုလာဘ်များကြီးမားလေဖြစ်သည်။",
    ifYou2:
      "အကယ်၍ သင်သည် လက်ရှိအဆင့်ထက် VIP အဆင့်နိမ့်သော VIP တစ်ဦးအဖြစ် ရွေးချယ်ခံရပါက၊ VIP အဆင့်သည် အသက်ဝင်မည်မဟုတ်ပါ။",
    theProgress:
      "ရင်ဘတ်ကီး၏ တိုးတက်မှုဘားကို နေ့စဉ် 00:00 (UTC+5:30) တွင် ပြန်လည်သတ်မှတ်ပါမည်",
  },
  share: {
    joinHala:
      "ဝင်ငွေအခွင့်အလမ်းများစွာကို သော့ဖွင့်ရန်နှင့် အေဂျင်စီများအတွက် အံဝင်ခွင်ကျဖြစ်သော အကျိုးခံစားခွင့်များနှင့် ဆုလာဘ်များကို ခံစားရန် Hala သို့ ဝင်ရောက်ပါ။",
    downloadTo: "ပါတနာဖြစ်လာရန် ဒေါင်းလုဒ်လုပ်ပါ။",
    joinHala2:
      "ပျော်ရွှင်စရာဂိမ်းများအတွက် Hala တွင်ပါဝင်ပြီး အံ့သြဖွယ်ဆုများရယူရန်အခွင့်အရေး။",
    downloadAnd: "ဒေါင်းလုဒ်လုပ်ပြီး Winning စတင်လိုက်ပါ။",
    joinHala3:
      "Hala တွင်ပါဝင်ပြီး သင်၏ hosting ခရီးကို စတင်လိုက်ပါ။ ၃၆ ဒေါ်လာအထိ နေ့စဉ် ဘောနပ်စ်များ ရယူပါ။",
    inviteYou: "အေဂျင်စီတွင် ပါဝင်ရန် ဖိတ်ခေါ်ပါသည်။",
    downloadNow: "Hosting စတင်ရန် ယခုဒေါင်းလုဒ်လုပ်ပါ။",
    comeWith: "Hala တွင် chat room သို့ ကျွန်ုပ်နှင့်အတူ လာပါ။",
    enthusiastsFrom:
      "ကမ္ဘာတဝှမ်းမှ ဝါသနာရှင်များ စုပေါင်းပြီး မျှဝေလိုက်ပါတယ်...",
    igniteEndless: "အဆုံးမဲ့ ပျော်ရွှင်မှုကို မီးမွှေးပါ။",
    download: "ဒေါင်းလုဒ်လုပ်ပါ။",
    halaLive: "Hala တိုက်ရိုက်",
    showMe: "ပျော်ရွှင်သောကမ္ဘာကိုပြသပါ။",
    saySomething: "တစ်ခုခုပြောပါ...",
    downloadHala: "Hala အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ။",
  },
  starHost: {
    starHost: "ကြယ်စင်",
    level2: "အဆင့် {level} ထိန်းသိမ်းပြီး {days} နေ့ရက်များ",
    currentSalary: "လက်ရှိလစာ",
    points: "Points",
    likes: "အကြိုက်များ",
    stillNeed: "Still need",
    done: "ပြီးပြီ။",
    numberOf2: "လက်ဆောင်ပေးသူအရေအတွက်",
    gifters: "လက်ဆောင်ပေးတယ်။",
    gcoinGifts: "Gcoin လက်ဆောင်များ",
    gifts: "gifts",
    liveDuration: "Live Duration",
    min: "မိ",
    completeAll: "အဆင့်မြှင့်ရန် အောက်ပါအလုပ်များအားလုံးကို ပြီးအောင်လုပ်ပါ။",
    follower: "နောက်လိုက်",
    numberOf3: "လက်ဆောင်ပေးသူအရေအတွက်",
    daysAt: "{level} Level တွင် နေ့ရက်များ",
    giftCollection: "လက်ဆောင် စုစည်းမှု",
    gift: "Gift",
    date: "Date",
    expectedSalary: "မျှော်မှန်းလစာ",
    gcoin: "Gcoin",
    status: "အဆင့်အတန်း",
    levelReached: " Level ပြီးပါပြီ။",
    notAchieved: "မအောင်မြင်ပါ။",
    starHost2: "ကြယ်ပွင့် စည်းမျဉ်း",
    eachStar: "Star Host တစ်ခုစီတွင် အစမ်းသုံးကာလ 3 ရက်ရှိသည်။",
    theyWill:
      "၎င်းတို့သည် 3 ရက်လုံးလုံး A-level စံနှုန်းများနှင့်ကိုက်ညီမှသာ တရားဝင် Star Host ဖြစ်လာပါမည်။",
    thoseWho:
      "နေ့စဉ် A အဆင့်ပစ်မှတ်များ ပြည့်မီရန် ပျက်ကွက်သူများကို အလုပ်ထုတ်မည်ဖြစ်သည်။",
    firedHosts: "အလုပ်ထုတ်ခံရသူများသည် Star Host အခြေခံလစာကို မရရှိနိုင်ပါ။",
    starHost3: "Star Host အခြေခံလစာကို အပတ်စဉ် တနင်္လာနေ့တိုင်း ပေးဆောင်ပါသည်။",
    ifA:
      "Star Host သည် နေ့စဥ်အလုပ်များကို ပြီးမြောက်ရန် ပျက်ကွက်ပါက၊ ၎င်းတို့သည် တစ်နာရီ လစာ၏ 50% ကိုသာ ရရှိမည်ဖြစ်သည်။",
    selfGifting:
      "လက်ဆောင်ပစ်မှတ်အားလုံးအတွက် မိမိကိုယ်ကို လက်ဆောင်ပေးခြင်းကို တင်းတင်းကျပ်ကျပ် တားမြစ်ထားသည်။",
    starHost4: "မတူညီသောအဆင့်များ၏ Star Host ဆုများ",
    level: "Level",
    dailyExtra: "နေ့စဉ် အပိုအမှတ်များ ဆုလာဘ်များ",
    liveBroadcast: "တိုက်ရိုက်ထုတ်လွှင့်ချိန် လိုအပ်သည်။",
    starHost5: "အဆင့်အမျိုးမျိုးအတွက် Star Host လိုအပ်ချက်",
    requirements: "လိုအပ်ချက်(များ)",
    yourApplication: "သင်၏လျှောက်လွှာကိုတရားဝင်မှအတည်ပြုသည်။",
    stayOn: "A အဆင့်တွင် 7 ရက်နေပါ။",
    over1k: "ပရိသတ် 1k ကျော်",
    totalGifter: "စုစုပေါင်းလက်ဆောင်အရေအတွက် > 300",
    receiveAll: '"Lucky" လက်ဆောင်များအားလုံးကို ရယူလိုက်ပါ။',
    everyLucky: "ကံကောင်းစေမည့် လက်ဆောင်အရေအတွက်တိုင်းသည် 100 ကျော်ရှိသင့်သည်။",
    stayOn2: "S-Level တွင် 10 ရက်နေပါ။",
    over2k: "ပရိသတ် 2k ကျော်",
    totalGifter2: "စုစုပေါင်းလက်ဆောင်အရေအတွက်> 300",
    receiveAll2: '"Hot" လက်ဆောင်အားလုံးကို ရယူလိုက်ပါ။',
    stayOn3: "SS-Level တွင် 10 ရက်နေပါ။",
    over5k: "ပရိသတ် 5k ကျော်",
    totalGifter3: "စုစုပေါင်းလက်ဆောင်အရေအတွက် > 1000",
    receiveAll3: '"ဇိမ်ခံ" လက်ဆောင်များအားလုံးကို လက်ခံပါ။',
    starHost6: "နေ့စဉ်လုပ်ငန်းဆောင်တာများကို ကြယ်ပွင့်ပြပါ။",
    dailyAssessment:
      "(နေ့စဉ်အကဲဖြတ်စနစ်): အပြန်အလှန်တုံ့ပြန်မှု / လက်ဆောင်များ",
    gcionGifts: "Gcion လက်ဆောင်များ",
    rulesTo: "Star Host အဆင့်ကို လျှော့ချရန် စည်းမျဉ်းများ",
    failTo:
      "လက်ရှိအဆင့်၏ စံနှုန်းများကို ၃ ရက်ဆက်တိုက် လိုက်နာရန် ပျက်ကွက်ခြင်း။",
    failingTo: "စံချိန်စံညွှန်းများကို <span>တစ်ပတ်အတွင်း ၃ ကြိမ် မပြည့်မီပါ။",
    ifThe2:
      "အကယ်၍ နေ့စဉ်လိုအပ်ချက်ကို ဖြည့်ဆည်းရန် ပျက်ကွက်သော အိမ်ရှင်သည် A-level ဖြစ်ပါက၊ သူမ/သူအား ရာထူးမှထုတ်ပယ်ခြင်း အစား တိုက်ရိုက်ထုတ်ပယ်ခြင်းခံရမည်ဖြစ်သည်။ ပျက်စီးသွားပြီးနောက်၊ အိမ်ရှင်သည် အဆင့်ပြန်လည်ရရှိရန် ၃ ရက်ဆက်တိုက် မူလအဆင့်စံနှုန်းများနှင့် ပြည့်မီရမည်",
    involvementIn:
      "ကြီးကြီးမားမားချိုးဖောက်မှုများ သို့မဟုတ် အပျက်သဘောဆောင်သည့် ဖြစ်ရပ်များတွင် ပါဝင်ပတ်သက်ခြင်း။",
    causingDamage:
      "ပလက်ဖောင်း၏ အကျိုးစီးပွား သို့မဟုတ် အမှတ်တံဆိပ်ပုံရိပ်ကို ထိခိုက်ပျက်စီးစေပါသည်။",
    applyFor: "အလုပ်ထွက်ရန် ကိုယ်တိုင်လျှောက်ထားပါ။",
    liveStreaming: "တိုက်ရိုက်ထုတ်လွှင့်မှု လိုအပ်ချက်များ",
    liveStream:
      "တိုက်ရိုက်ထုတ်လွှင့်မှု အကြောင်းအရာသည် လက်ခံသူ၏ သတ်မှတ်ထားသော အမျိုးအစားနှင့် ကိုက်ညီရပါမည်။",
    roomHosts:
      "ထုတ်လွှင့်မှုအတွင်း သက်တမ်းတိုးနေချိန်အတွင်း အခန်းဝန်ဆောင်မှုပေးသည့် မိုက်ခရိုဖုန်းကို အသံတိတ်ရန် တားမြစ်ထားသည်။",
    liveStreams:
      "ဆံ့ မိုက်ခရိုဖုန်း အခန်းအပြင်အဆင်ကို အသုံးပြု၍ တိုက်ရိုက်ထုတ်လွှင့်မှုများကို ပြုလုပ်ရပါမည်။",
    otherSeats:
      "လုပ်ငန်းဆောင်တာရည်ရွယ်ချက်အတွက် ၎င်းတို့၏မိုက်ခရိုဖုန်းကို အသံပိတ်ထားသော အသုံးပြုသူများ သို့မဟုတ် ပရိသတ်အဖွဲ့ဝင်များက အခန်းအတွင်းရှိ အခြားထိုင်ခုံများကို သိမ်းပိုက်ခွင့်မပြုပါ။",
    discriminatoryInsulting:
      "ခွဲခြားဆက်ဆံခြင်း၊ စော်ကားခြင်း သို့မဟုတ် ပုတ်ခတ်ပြောဆိုခြင်းများကို အခန်းထဲတွင် တင်းတင်းကျပ်ကျပ် တားမြစ်ထားသည်။",
  },
  starRoom: {
    afterCountdown:
      "နေ့စဉ်နှစ်သစ်ရေတွက်ပြီးနောက်၊ Top3 အခန်းများကို Star Room Rank တွင်စာရင်းသွင်းပါမည်။",
    top20Star:
      "ထိပ်တန်းကြယ်ပွင့် 20 အခန်းများကို ယခုသီတင်းပတ်ပြီးနောက် များပြားလှသော ဘောနပ်စ်အဖြစ် ဆုချီးမြှင့်ပါမည်။",
    countdown: "Countdown：",
    top3Daily:
      "Top3 နေ့စဉ် top3 အခန်းများသည် အပတ်စဉ် ကြယ်ပွင့်အခန်းများ ပါဝင်ရန် အရည်အချင်းပြည့်မီပါမည်။",
    starRooms:
      "သီတင်းပတ်၏နောက်ဆုံးနေ့တွင် ကြယ်ပွင့်အခန်းများကို အဆင့်သတ်မှတ်မည်ဖြစ်သည်။ အခန်းတိုင်း၏ စုစုပေါင်းဒင်္ဂါးပြားစီးဆင်းမှုအရ ၎င်းကို အဆင့်သတ်မှတ်မည်ဖြစ်သည်။",
    top20Weekly:
      "အပတ်စဉ် ထိပ်တန်းကြယ်ပွင့် 20 အခန်းပိုင်ရှင်များသည် အောက်ပါအတိုင်း ဆုလက်ဆောင်များ ရရှိပါမည်။",
    qualificationTo:
      "ဤအစီအစဉ်တွင် ပါဝင်ရန် အရည်အချင်း- ချိုးဖောက်မှု သို့မဟုတ် တရားမဝင်သော အပြုအမူမှန်သမျှကို အခန်းထဲတွင် ခွင့်မပြုပါ၊ တွေ့ရှိပါက၊ hala သည် အခန်းကို အရည်အချင်းပြည့်မီပြီး အဆင့်မှ ဖယ်ရှားပါမည်။",
    theRewards: "ဆုလက်ဆောင်များကို တနင်္လာနေ့တိုင်း ပေးပို့မည်ဖြစ်ပါသည်။",
    days: "days",
    coins: "Coins",
  },
  inviteActive: {
    inviteHosts: "အိမ်ရှင်များကို ဖိတ်ကြားပါ။",
    pointsMax: "နေ့စဉ် အမှတ်အများဆုံး 5,000",
    firstRecharge: "ပထမဦးစွာ အသုံးပြုသူများကို အားပြန်သွင်းပါ။",
    get20: "$20 အခမဲ့ရယူလိုက်ပါ။",
    oneInvite:
      "1. သင်ဖိတ်ကြားထားသည့် အိမ်ရှင်များ ပြီးဆုံးသောအခါ တိုက်ရိုက်လွှင့်ရန် အိမ်ရှင်များကို ဖိတ်ကြားပါ။",
    aFinish: "a အလုပ်ဌာနတွင် မျက်နှာအတည်ပြုခြင်းကို အပြီးသတ်ပါ။",
    bCreate: "ခ။ သူ့ကိုယ်ပိုင်အခန်းကို ဖန်တီးပါ။",
    cLive: "c.သူမ၏အခန်းတွင် 3 နာရီကြာ မိုက်ဖြင့်နေထိုင်ပါ။",
    dClaim: "d. တိုက်ရိုက်ဆုလက်ဆောင်များကို ပထမဆုံးအကြိမ် တောင်းဆိုပါ။",
    youGet:
      "သင်၏ တရားဝင် ဖိတ်ကြားထားသော အိမ်ရှင်နံပါတ်များမှ အမှတ်များ နေ့တိုင်း ရရှိပါသည်။ နောက်နေ့တွင် ဆုလက်ဆောင်များကို ရယူနိုင်ပါသည်။",
    validHost: "တရားဝင်အိမ်ရှင်",
    pointsReward: "အမှတ်များဆုလာဘ်",
    youCan: " You can earn up to 5,000 invite points per day",
    myInvited: "ကျွန်ုပ်၏ ဖိတ်ကြားထားသော အိမ်ရှင်များ",
    validHosts: "ယနေ့ တရားဝင် လက်ခံဆောင်ရွက်ပေးသူများ",
    pointsRewards: "အမှတ်များ ဆုလာဘ်များ",
    validHosts2: "အကျုံးဝင်သော အိမ်ရှင်များ မနေ့က-",
    claim: "တောင်းဆိုမှု",
    claimed: "တိုင်ကြားထားသည်။",
    completedTime: "ပြီးစီးချိန်",
    ifYour:
      "သင့်သူငယ်ချင်းများ ပထမအကြိမ်ငွေဖြည့်ခြင်းပြီးဆုံးပါက၊ သင်သည် ဆုလာဘ်များစွာကို ရရှိမည်ဖြစ်ပါသည်။(အော့ဖ်လိုင်းအားပြန်သွင်းခြင်းလည်း ပါဝင်ပါမည်)။",
    theMore:
      "ပထမအကြိမ် ငွေဖြည့်သွင်းသည့်ပမာဏ ပိုများလေ၊ သင့်အား ဒင်္ဂါးပြားများ များများချီးမြှင့်လေဖြစ်ပြီး ၎င်းသည် နေ့စဉ် $20 အထိ ရှိသည်။",
    inviteesRecharge: "ဖိတ်ကြားသူများသည် ဒင်္ဂါးပြားများကို ပြန်ဖြည့်ပါ။",
    yourReward: "သင်၏ဆုငွေဒင်္ဂါးပြားများ",
    threeOnly:
      "3. ရက်ပေါင်း 30 အတွင်း ဖိတ်ခေါ်ခံရသော အသုံးပြုသူများကိုသာ တရားဝင် ပထမအကြိမ် ငွေပြန်ဖြည့်သည့် သုံးစွဲသူများအဖြစ် ရေတွက်မည်ဖြစ်သည်။",
    seniorAnd:
      "အကြီးတန်းနှင့် ပုံမှန်ရောင်းချသူအား အက်ပ်မှ သို့မဟုတ် တရားဝင်တိုက်ရိုက်ငွေပြန်သွင်းသည့်အခါမှသာ (ငွေပေးချေမှုနည်းလမ်းများအတွက် သင့်စီမံခန့်ခွဲသူထံသို့) ပထမဆုံးအကြိမ်အဖြစ် မှန်ကန်သော ပထမဆုံးငွေပြန်ဖြည့်သည့်အသုံးပြုသူများအဖြစ် ထည့်သွင်းရေတွက်မည်ဖြစ်သည်။",
    myInvited2: "ကျွန်ုပ်၏ ဖိတ်ကြားထားသော အသုံးပြုသူများ",
    rechargeCoins: "ဒင်္ဂါးပြားများ အားပြန်သွင်းပါ။",
    coinsRewards: "ဒင်္ဂါးပြားဆုလာဘ်များ",
    firstRecharge2: "မနေ့က ပထမဆုံး ငွေဖြည့်ဒင်္ဂါးများ-",
    firstRecharge3: "ပထမဆုံး ငွေဖြည့်ဒင်္ဂါးများ",
    firstRecharge4: "ပထမဆုံး အားပြန်သွင်းချိန်",
  },
  hostPolicy: {
    title: "အိမ်ရှင်မူဝါဒ",
    section1Title: "အသစ်အိမ်ရှင်များအတွက် ပထမအပတ်အခြေခံလစာ",
    requirement: "လိုအပ်ချက်",
    newHostsDesc: "ပထမအပတ်တွင် Hala သို့ဝင်ရောက်သော အသစ်အိမ်ရှင်များ",
    activeTime: "မိုက်ခရွန်းပေါ်တွင် �လှုပ်ရှားမှုအချိန်",
    oneHour: "၁ နာရီ",
    twoHour: "၂ နာရီ",
    threeHour: "၃ နာရီ",
    baseSalary: "အခြေခံလစာ (အမှတ်များ)",
    incomeRequirement: "ဝင်ငွေလိုအပ်ချက်",
    none: "မရှိ",
    remarks: "မှတ်ချက်",
    remarksDesc:
      "တစ်ရက်လျှင် အများဆုံး ၃ နာရီ။ အများဆုံး ၇ ရက်။ စုစုပေါင်းအများဆုံးဆု ၃၅,၀၀၀ အမှတ်",
    note1:
      "အိမ်ရှင်မှတ်ပုံတင်သည့်ရက်မှစ၍ ၇ ရက်အခြေခံလစာသက်တမ်းကာလကို စတင်ရေတွက်ချိန်သည်။",
    note2:
      "များစွာသောအကောင့်များသုံးစွဲခြင်းသို့မဟုတ် များစွာသော IP သို့မဟုတ် ပစ္စည်းများဖြင့်ဝင်ရောက်သော အိမ်ရှင်များကို အခြေခံလစာဆုမှ ပယ်ဖျက်ခံရပါမည်။",
    note3:
      "အိမ်ရှင်၏နောက်ဆုံး ၇ ရက်ဝင်ငွေသည် ၁၅၀,၀၀၀ အမှတ်ထက်ကျော်လွန်ပါက၊ သူမသည် အသစ်အိမ်ရှင်အခြေခံလစာဆုအစား ပုံမှန်အိမ်ရှင်နာရီစာရင်းဆုကို ရရှိပါမည်။",
    section2Title: "ပုံမှန်အိမ်ရှင်ညီမျှဆု",
    level: "အဆင့်",
    incomeRequirementShort: "ဝင်ငွေလိုအပ်ချက်",
    hourlyReward: "နာရီစာရင်းဆု",
    maximumDailyHours: "နေ့စဉ်အများဆုံးနာရီ",
    section2Note1:
      "မိုက်ခရွန်းပေါ်တွင် ဆက်တိုက် ၁၅ မိနစ်ကို ထိရောက်သောအချိန်အဖြစ် ရေတွက်သည်။",
    section2Note2:
      "ဆုအားလုံးကို အမှတ်များဖြင့် ပေးဆောင်ပြီး လုပ်ဆောင်ရေးစနစ်တွင် တောင်းဆိုရပါမည်။",
    section2Note3:
      "ပလက်ဖောင်းဆုများကို အမှတ်လိုအပ်ချက်တွင် ထည့်သွင်းမည်မဟုတ်ပါ။",
    section2Note4:
      "များစွာသော IP သို့မဟုတ် ပစ္စည်းများကို ရှာဖွေတွေ့ရှိပါက အမှတ်များကို နုတ်ပယ်ပါမည်။",
    section2Note5:
      "ကမ္ဘာ့နောက်ဆုံး ၇ ရက်သည် နောက်ဆုံး ၆ ရက်+ယနေ့ကို ဆိုလိုသည်၊ ထို့ကြောင့် သင်သည် အချိန်မှန်ပိုမြင့်သောအမှတ်အဆင့်ကို ရောက်ရှိလာသည်နှင့်အမျှ သင့်နာရီစာရင်းဆုများ ပိုမိုရရှိနိုင်ပါသည်။",
    section2Note6:
      "L-အဆင့် မပါဝင်သောဆုများသည် မှတ်ပုံတင်ပြီးနောက် ပထမ ၇ ရက်အတွင်းသာ အသက်ဝင်ပါမည်။ ၇ ရက်ပြည့်ပါက၊ အိမ်ရှင်များသည် အမြဲတမ်းနေ့စဉ် အခမဲ့အမှတ် ၅၀၀ ရရှိနိုင်ပါသည်။",
    section3Title: "အိမ်ရှင်စည်းမျဉ်းများ",
    regulation1:
      "အိမ်ရှင်များသည် များစွာသောအကောင့်များကို မှတ်ပုံတင်ခြင်းကို တားမြစ်ထားသည်။",
    regulation2: "တတိယပါဝါပလက်ဖောင်းများကို မြှောက်စေခြင်းကို တားမြစ်ထားသည်။",
    regulation3: "အသက်မပြည့်သူများကို တင်းကျပ်စွာ တားမြစ်ထားသည်။",
    regulation4:
      "အိမ်ရှင်တစ်ဦးတွင် အတည်ပြုထားသော ID တစ်ခုသာရှိနိုင်သည်။ အတည်ပြုထားသော ID များသာ တိုက်ရိုက်ထုတ်လွှင့်မှုကို စတင်နိုင်ပြီး ဝင်ငွေများကို ထုတ်ယူနိုင်သည်။",
    regulation5:
      "တိုက်ရိုက်ထုတ်လွှင့်မှုကို စတင်ရန် သို့မဟုတ် ဝင်ငွေများကို ထုတ်ယူရန် မျက်နှာအသိအမှန်ခံကို လှည့်ဖျားသည့် လုပ်ရပ်မည်သို့ကိုမဆို အမြဲတမ်းပိတ်ပင်ခံရပါမည်။",
    regulation6:
      "တိုက်ရိုက်ထုတ်လွှင့်မှုအတွက် အခြားသူများကို ID ပေးခြင်းသည် ID ကို စနစ်မှ အမြဲတမ်းပိတ်ပင်ခံရမည့်အဖြစ် သေချာပါသည်။",
    regulation7:
      "အသံခန်းထဲတွင်၊ အိမ်ရှင်များသည် ခန်းထဲသို့ ဝင်ရောက်သူအသုံးပြုသူများကို တက်ကြွစွာ နှုတ်ဆက်သင့်ပါသည်။",
    regulation8:
      "အသံခန်းအဖုံးပုံသည် အိမ်ရှင်၏ အစစ်အမှန်၊ လိုက်လျောညီသောဓာတ်ပုံကို သုံးစွဲရပါမည်။",
    regulation9:
      "Hala ပလက်ဖောင်းသည် လိမ်လည်မှုလုပ်ငန်းမည်သို့ကိုမဆို တင်းကျပ်စွာ တားမြစ်ထားသည်။ မည်သည့်ချိုဖော်မှုကိုမဆို အကောင့်အမြဲတမ်းရပ်ဆိုင်းခံရမည်ဖြစ်သည်။",
    footer:
      "Hala သည် အထက်ပါမူဝါဒများ၏ နောက်ဆုံးအနက်ဖွင့်ဆိုချက်အခွင့်အရေးကို လက်ဝယ်ထားသည်။",
  },
  correspondingRevenue:
    "သက်ဆိုင်ရာဝင်ငွေလိုအပ်ချက်များနှင့်ပြည့်မီပါက။ ဆုချီးမြှင့်မှုအားလုံးကိုထုတ်ပြန်လိမ့်မည်",
  within12: "ပွဲပြီးဆုံးပြီးနောက် 1-2 ရက်အလုပ်ချိန်အတွင်း",
};
